<script lang="ts">
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import logoImage from "../../../../core/assets/logo.svg";
	import { appName } from "../../../../core/schema/names/appName.js";
	import type { ProductForCustomer } from "../../../../core/schema/Product";
	import { getGlobalSettings } from "../../getGlobalSettings";
	import { getImagesForProduct } from "../../../../core/schema/utils/getImagesForProduct.js";
	import type { ProductSize } from "../../../../core/schema/ProductSize.js";

	interface LogoProps {
		size: number;
		class?: string;
	}

	export let product: ProductForCustomer;
	export let loading: "lazy" | "eager" = "lazy";
	export let size: number;
	export let selectedSize: ProductSize;
	export let logo: LogoProps | null = null;

	const { TENANT_LOCALE } = getGlobalSettings();

	$: [primaryImg, secondImage] = getImagesForProduct(product, selectedSize);
	$: secondaryImg = product.sliceImage ?? secondImage;
</script>

{#if primaryImg}
	<DynamicPicture
		class={secondaryImg ? "h-full w-full transition-all duration-300" : ""}
		imgClass="w-full h-full rounded-lg aspect-square object-cover"
		image={primaryImg}
		width={size}
		height={size}
		bucket="storage"
		{loading}
		preload={loading === "eager"}
		alt="Fotografie – {product.name[TENANT_LOCALE]}"
	/>
{:else if logo}
	<div class="bg-secondary-40 group flex h-full w-full items-center justify-center rounded-lg">
		<StaticPicture
			alt="Logo {appName}"
			image={logoImage}
			class="opacity-50 transition-all duration-300 group-hover:opacity-100 {logo.class}"
			{loading}
			preload={loading === "eager"}
			width={logo.size}
			height={logo.size}
		/>
	</div>
{/if}
{#if secondaryImg}
	<DynamicPicture
		class="absolute inset-0 h-full w-full opacity-0 transition-opacity duration-300 group-hover:opacity-100"
		imgClass="h-full w-full object-cover rounded-lg"
		image={secondaryImg}
		width={size}
		height={size}
		bucket="storage"
		{loading}
		preload={loading === "eager"}
		alt="Fotografie – {product.name[TENANT_LOCALE]}"
	/>
{/if}
